import { render, staticRenderFns } from "./ProfileReadMyStory.vue?vue&type=template&id=07ac32e3&scoped=true"
import script from "./ProfileReadMyStory.vue?vue&type=script&lang=js"
export * from "./ProfileReadMyStory.vue?vue&type=script&lang=js"
import style0 from "./ProfileReadMyStory.vue?vue&type=style&index=0&id=07ac32e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ac32e3",
  null
  
)

export default component.exports